/* eslint-disable import/no-unresolved */
import { i18nClient } from '@sailor/i18n-mach-pro/lib';
import * as React from 'react';
import { CommonHeaders } from '@/src/pages/shop/c_shop_golden/utils/commonHeaders';
import { SOURCE_MULTI_SKU_NUM, UserGetMode, TOAST_TYPE } from '@/components/MultiSkuModalGolden/constant';
import { shopMonitor } from '@/src/pages/shop/c_shop_golden/utils/Monitor';
import { logan } from '@/components/MultiSkuModalGolden/utils/logan';
import {
  GoodDetailData, GoodDetailGroupList, DefaultGoodDetail, GoodDetailSkuList, DefaultGroupSkuList,
  FullDiscountExtraInfo,
  SelectedGroupSkuList
} from '@/pages/shop/c_shop_golden/component';
import { SelectedSku, RequairedSkuGroup } from '@/components/MultiSkuModalGolden/Store/model';
import { MultiSkuRequest } from '@/components/MultiSkuModalGolden/Components/MultiSkuRequest';
import {
  SHOPURL, MULTI_SKU_ERROR_CODE, CALCULATE_PRICE_STATUS, PRODUCT_SPEC_STATUS, BundleVersion
} from '@/pages/shop/c_shop_golden/utils/constant';
import { MutliSKUModalMonitor, MULTI_SKU_MODAL_MONITOR_VALUE } from '@/components/MultiSkuModalGolden/utils/Monitor';
import { getMultiSkuModalABTest } from '@/components/MultiSkuModalGolden/utils';

const Toast = Mach.requireModule('Toast');
const Dialog = Mach.requireModule('Dialog');
const networkModule = Mach.requireModule('Network');
const Location = Mach.requireModule('SLLocation');

// const indicatorModule = Mach.requireModule('ActivityIndicator');

export class MultiSkuStore {
  curGoodDetail = {} as GoodDetailData; //网络请求回来的选规格数据

  selectedList = [] as SelectedSku[]; //已选择的sku和groupList数组，存已选数据

  requiredSkuList = [] as RequairedSkuGroup[]; //必选sku和 groupList的映射

  defaultGoodData = {} as DefaultGoodDetail | undefined; //购物车进来的当前菜品数据

  cartSkuList = [] as DefaultGoodDetail[] | undefined; //购物车内其他菜品数据

  countNumber: number = 1; //选购份数

  requestCalList = [] as SelectedSku[]; //用于请求计价接口的数据，与已选数据做区分

  shopInfoExtra = {}; //用于请求接口

  calStatus: number = CALCULATE_PRICE_STATUS.SUCCESS; //计价接口的请求状态

  specStatus: number = PRODUCT_SPEC_STATUS.SUCCESS; //规格接口的请求状态

  mulitSkuModalMonitor: MutliSKUModalMonitor = new MutliSKUModalMonitor();

  multiSkuModalABTest = false; // 多规格页ab实验-置顶&锚定

  //请求接口
  public loadData = (params: { spuId: number; shopId: string; couponInfo: any[]; requestSource: number; btnText: string; productCartIndex?: number; func?: Function; activityId?: string; sameShopSpuIdList?: number[]; userGetMode: UserGetMode; }, callback: Function, showMultiSkuDirectly: boolean, defaultGoodData?: DefaultGoodDetail, cartSkuList?: any) => {
    this.setSpecStatus(PRODUCT_SPEC_STATUS.LOADING);
    this.defaultGoodData = defaultGoodData;
    this.cartSkuList = cartSkuList;
    const locationObj = Location?.getLocation();
    const param = {
      spuId: params.spuId,
      shopId: params.shopId,
      chooseSku: defaultGoodData,
      channelCode: defaultGoodData?.channelCode || 0,
      requestSource: params.requestSource,
      couponInfo: params.couponInfo,
      latitude: locationObj?.latitude,
      longitude: locationObj?.longitude,
      actualLatitude: locationObj?.actualLatitude,
      actualLongitude: locationObj?.actualLongitude,
      cartSkuList,
      activityId: params.activityId,
      userGetMode: params.userGetMode,
      sameShopSpuIdList: params?.sameShopSpuIdList,
      bundleVersion: BundleVersion
    };
    this.shopInfoExtra = param;
    const errCodes = [MULTI_SKU_ERROR_CODE.UNAVAILABLE];
    MultiSkuRequest(param, showMultiSkuDirectly)
      .then((res) => {
        this.setSpecStatus(PRODUCT_SPEC_STATUS.SUCCESS);
        if (res) {
          this.curGoodDetail = res;
          //保存必选分类ListMap
          for (let i = 0; i < this.curGoodDetail.skuList.length; i++) {
            const groupList: GoodDetailGroupList[] = this.curGoodDetail.skuList[i].groupList;
            const skuID = this.curGoodDetail.skuList[i].skuId;
            const mustGroupList: any = [];
            if (groupList) {
              groupList.forEach((item) => {
                if (item.minNumber > 0) {
                  mustGroupList.push({ groupId: item.groupId, minCount: item.minNumber, ref: React.createRef() });
                }
              });
              const test = new RequairedSkuGroup(skuID, mustGroupList);
              this.requiredSkuList.push(test);
            } else {
              const test = new RequairedSkuGroup(skuID, []);
              this.requiredSkuList.push(test);
            }
          }
        }
        // 价格隔离：商品价格变化 异常toast
        const toastText = this.curGoodDetail?.toastInfo?.toastText || '';
        const toastType = this.curGoodDetail?.toastInfo?.toastType;
        if (toastType === TOAST_TYPE.PRICE_CHANGE && toastText) {
          Toast.show(toastText, 2);
        }
        // 多规格页ab实验-置顶&锚定
        this.multiSkuModalABTest = getMultiSkuModalABTest(this.curGoodDetail);
        callback(true, this.curGoodDetail, 0);
      }, (result) => {
        this.setSpecStatus(PRODUCT_SPEC_STATUS.ERROR);
        const errMsg = result.data.message || i18nClient.getText('shouye_default_4');
        const showToast = errCodes.find((code) => (code === result?.data?.code));
        const func = params.func;
        if (result?.data?.code === MULTI_SKU_ERROR_CODE.STYSTEMERROR) {
          const toastDuration = 1;
          Toast.show(errMsg, toastDuration, {
            code: result?.data?.code || '0',
            extraInfo: {
              msg: errMsg,
              method: 'MultiSkuStore.loadData-STYSTEMERROR',
            }
          });
          if (params.requestSource >= SOURCE_MULTI_SKU_NUM.NINE_ONE_NINE && func) {
            setTimeout(() => {
              func(params?.spuId);
            }, toastDuration * 1000);
          }
        } else if (result?.data?.code === MULTI_SKU_ERROR_CODE.DISCOUNT_FOOD_SOLD_OUT) {
          // 价格隔离：商品价格变化或折扣菜售罄 异常toast
          Toast.show(errMsg, 2);
          setTimeout(() => {
            func && func();
          }, 2000);
        } else {
          //主站门店逻辑
          if (params.requestSource === SOURCE_MULTI_SKU_NUM.SHOP_PREVIEW) {
            if (showToast) {
              Toast.show(errMsg, 2);
              if (func) {
                if (params.productCartIndex !== undefined) {
                  func(params.productCartIndex);
                } else {
                  setTimeout(() => {
                    func();
                  }, 2000);
                }
              }
            } else {
              Dialog?.show({
                level: 1, //加上level为1 ，解决iOS端在machpro弹窗容器上再次弹窗时，无法点击的问题
                title: errMsg,
                rightButtonTitle: params.btnText,
              }, (result: any) => {
                if (result.which === -1) {
                  Mach.requireModule('Router').navigateBack();
                }
              });
            }
          } else { //一口价门店逻辑、919活动, 其它活动
            Dialog?.show({
              level: 1, //加上level为1 ，解决iOS端在machpro弹窗容器上再次弹窗时，无法点击的问题
              title: errMsg,
              rightButtonTitle: params.btnText,
            }, (result: any) => {
              if (result.which === -1 && func) {
                func(params?.spuId);
              }
            });
          }
        }
        callback(false, this.curGoodDetail, result?.data?.code);
      })
      .catch((error) => {
        this.setSpecStatus(PRODUCT_SPEC_STATUS.ERROR);
        console.log('请求失败error', error);
        callback(false);
      });
  };

  //初始化数据
  public initDetailData = (shopId, skuList: GoodDetailSkuList[], chooseSkuId: number | undefined): GoodDetailSkuList => {
    let index = 0;
    skuList.forEach((item: GoodDetailSkuList) => {
      this.selectedList.push({
        skuId: item.skuId,
        groupList: [],
        fullDiscountExtraInfo: item.fullDiscountExtraInfo,
        discountPriceList: item.discountPriceList,
        activityInfoList: item.activityInfoList,
      });
    });
    if (this.defaultGoodData) {
      const data = this.defaultGoodData;
      this.countNumber = this.defaultGoodData?.count;
      index = skuList.findIndex((value) => value.skuId === data.skuId);
      if (index < 0) {
        // 传入的选中菜品不在规格列表中
        logan({
          message: 'skuId not in multiSkuModal',
          shopId,
          index,
          // 异常场景SkuId
          errorSelectedSkuId: data.skuId,
          // 默认选中的skuid
          defaultSelectedSkuId: skuList?.[index]?.skuId,
          skuList,
          defaultGoodData: this.defaultGoodData
        });
        shopMonitor.reportMetrics({
          SkuIdNotInMultiSkuModal: 1
        });
      }
      index = index < 0 ? 0 : index;
      this.selectedList.forEach((item) => {
        if (item.skuId === data.skuId) {
          item.groupList = this.replenishSkuGroupList();
        }
      });
    } else if (chooseSkuId !== null) {
      //通过接口返回的chooseSkuId字段 确认默认选择的规格
      index = skuList.findIndex((value) => value.skuId === chooseSkuId);
      index = index < 0 ? 0 : index;
    }
    skuList.forEach((item: GoodDetailSkuList) => {
      //新增初始化判断group是否必须全选，全选的话需要默认选好
      //1.7.200新增复选逻辑，非复选情况下才默认全选
      const foundItem = this.selectedList.find((element) => element.skuId === item.skuId);
      const groupListTest: any[] = foundItem?.groupList || [];
      item.groupList?.map((groupListTemp: GoodDetailGroupList) => {
        if (!groupListTemp.repeatable && groupListTemp.minNumber === groupListTemp.groupSkuList?.length && groupListTemp.minNumber !== 0) {
          const newGroupSkuList = groupListTemp.groupSkuList.map((item) => ({ ...item, count: 1 }));
          const hasGroupSku = groupListTest?.find((item) => item.groupId === groupListTemp.groupId);
          if (!hasGroupSku) {
            groupListTest.push({
              groupId: groupListTemp.groupId,
              groupSkuList: newGroupSkuList
            });
          }
        }
      });

      if (foundItem) {
        this.selectedList.forEach((data) => {
          if (item.skuId === data.skuId) {
            data.groupList = groupListTest;
          }
        });
      } else {
        this.selectedList.push({
          ...item,
          groupList: groupListTest,
        });
      }
    });
    this.requestCalList = this.selectedList;
    return skuList[index];
  }

  //切换sku,根据找对应已选sku的groupList,没选过的话就是空的
  public getSelectedGroupListBySkuId = (skuId: number) => this.selectedList.find((item) => (item.skuId === skuId))?.groupList || []

  //根据skuId找必选品列表
  public getRequiredListBySkuId = (skuId: number) => this.requiredSkuList.find((item) => (item.skuId === skuId))?.groupList || []

  public clearSelectedList = () => {
    this.selectedList = [];
    this.requestCalList = [];
  }

  /**
     * 变更groupItem，存到前端selectedList
     * @param skuId //当前skuId
     * @param groupId //变更的groupId
     * @param groupSkuList //变更的groupSku
     *
     */
  public changeGroupItemBySkuId = (skuId: number, groupId: number, groupSkuList: SelectedGroupSkuList[]) => {
    let selectedSkuGroupList = this.selectedList.find((item) => (item.skuId === skuId))?.groupList;
    if (!selectedSkuGroupList || selectedSkuGroupList.length === 0) {
      selectedSkuGroupList = [{ groupId, groupSkuList }];
    } else {
      const groupIndex = selectedSkuGroupList.findIndex((item) => groupId === item.groupId);
      if (groupIndex >= 0 && selectedSkuGroupList.length) {
        selectedSkuGroupList[groupIndex].groupSkuList = groupSkuList;
        //如果为空则删除当前数组中的对象
        if (groupSkuList.length === 0) {
          selectedSkuGroupList.splice(groupIndex, 1);
        }
      } else {
        selectedSkuGroupList.push({ groupId, groupSkuList });
      }
    }
    this.requestCalList.forEach((item) => {
      if (item.skuId === skuId) {
        item.groupList = selectedSkuGroupList;
      }
    });
  }

  public changeSelectedList = (selectedSkuId: number, fullDiscountExtraInfo: FullDiscountExtraInfo) => {
    this.selectedList.forEach((item) => {
      if (item.skuId === selectedSkuId) {
        item.fullDiscountExtraInfo = fullDiscountExtraInfo;
      }
    });
  }

  /**
     * 必选品校验
     * @param selectedSku//已选择的sku及对应属性‘
     * @return boolean //必选品校验是否通过
     */

  public verificateProducts = (selectedSku: GoodDetailSkuList): boolean => {
    if (!selectedSku) {
      return false;
    }
    const mustGroupList = this.getRequiredListBySkuId(selectedSku.skuId);
    let isAllChecked = !(mustGroupList?.length > 0);
    if (!isAllChecked) {
      const lab = this.getHighlightGroupBySkuId(selectedSku.skuId);
      isAllChecked = lab.length === 0;
    }
    return isAllChecked;
  }

  //找到没有满足最少必选的group
  public getHighlightGroupBySkuId = (skuId: number): number[] => {
    const mustList = this.getRequiredListBySkuId(skuId);
    const lab: number[] = [];
    mustList.forEach((mustGroup) => {
      const minCount = mustGroup.minCount;
      const groupID = mustGroup.groupId;
      const selectedSku = this.getSelectedGroupListBySkuId(skuId);
      const selectedGroupList = selectedSku.find((item) => (item.groupId === groupID));
      const selectedCount = selectedGroupList?.groupSkuList.reduce((total, obj) => total + obj.count, 0);
      if (!selectedCount || !selectedSku || minCount > selectedCount) {
        lab.push(groupID);
      }
    });
    return lab;
  }

  /**
     * 构造数据去请求购物车接口
     * @param headers
     * @returns
     */
  public createRequestData = (source: number, sku: GoodDetailSkuList, count: number, groupId?: number, groupSkuList?: SelectedGroupSkuList[], couponInfo?: any[], activityId?: string) => {
    if (groupId && groupSkuList) {
      this.changeGroupItemBySkuId(sku.skuId, groupId, groupSkuList);
    }
    const selectedSkuGroupList = this.requestCalList.find((item) => (item.skuId === sku.skuId))?.groupList || [];
    const isDefaultSku = this.defaultGoodData?.skuId === sku.skuId;
    const chooseSku = {
      count,
      skuId: sku.skuId,
      // 与productspec接口的discountPrice字段属性不一致，此discountPrice为当前选中sku的折扣价格
      discountPrice: sku.discountPrice,
      couponInfo,
      originPrice: sku.originPrice,
      spuName: this.curGoodDetail.name,
      spuId: this.curGoodDetail.spuId,
      groupList: selectedSkuGroupList,
      activityId,
      soldOutType: isDefaultSku ? this.defaultGoodData?.soldOutType : 0,
    };
    const calculatePriceParams = {
      ...this.shopInfoExtra,
      chooseSku,
      channelCode: this.defaultGoodData?.channelCode || 0,
      cartSkuList: this.cartSkuList,
    };
    // 监控chooseSku中skuId为空的情况
    if (!sku.skuId) {
      logan({
        message: 'multisku calculatePrice params error',
        source,
        calculatePriceParams,
      });
      this.mulitSkuModalMonitor.multiSkuModalProductPriceParams(MULTI_SKU_MODAL_MONITOR_VALUE.SUCCESS, calculatePriceParams);
    }
    return calculatePriceParams;
  }

  /**
     * 修改当前计价接口状态
     */

  public changeCalStatus = (status: number) => {
    this.calStatus = status;
  }

  /**
     * 获取当前计价接口状态
     */
  public getCalStatus = (): number => this.calStatus

  public setSpecStatus = (status: number) => {
    this.specStatus = status;
  }

  public getSpecStatus = (): number => this.specStatus

  /**
     * 多规格浮层请求后端计价接口
     * @param data //请求入参
     * @returns 价格
     */
  public calByBE = (data: any, headers = {}) => {
    // indicatorModule.showLoading();
    this.calStatus = CALCULATE_PRICE_STATUS.LOADING;
    const locationObj = Location?.getLocation();
    const param = {
      ...data,
      bundleVersion: BundleVersion,
      latitude: locationObj.latitude,
      longitude: locationObj.longitude,
      actualLatitude: locationObj?.actualLatitude,
      actualLongitude: locationObj?.actualLongitude
    };
    const params = {
      url: SHOPURL.MULTISKUCALCULATE,
      method: 'POST',
      dataType: 'json',
      data: param,
      headers: {
        ...CommonHeaders.getCommonHeader(),
        ...headers
      }
    };
    return new Promise<any>((resolve, reject) => {
      networkModule.requestWx(params, (result: any) => {
        // indicatorModule.hideLoading();
        if (result.error) {
          console.log(`PriceCalculate request api error: ${JSON.stringify(result.error)}`);
          this.requestCalList = this.selectedList;
          reject(result.error);
        } else {
          console.log('PriceCalculate request api success!');
          if (result.data && result.data.code === 0 && result.data.data) {
            this.selectedList = this.requestCalList;
            // ----- mpweb适配origin -----
            // resolve(result.data.data);
            // ----- mpweb适配change -----
            if (window.__nol) {
              resolve({
                ...result.data.data,
                discountPrice: result.data.data.originPrice,
              });
            } else {
              resolve(result.data.data);
            }
            // ----- mpweb适配       -----
          } else {
            this.requestCalList = this.selectedList;
            reject(result.data);
          }
        }
      });
    });
  }

  /**
     * 计算购物车当前商品的spu数量，用于限购逻辑计算
     * @returns 购物车当前商品的spu数量
     */
  public spuCountInCart = (): number => {
    let spuCount = 0;
    if (this.cartSkuList) {
      for (let i = 0; i < this.cartSkuList.length; i++) {
        if (this.cartSkuList[i].spuId === this.curGoodDetail.spuId) {
          spuCount += this.cartSkuList[i].count;
        }
      }
    }
    return spuCount;
  }

  public getScreenBottom(defaultBottom = 12) {
    let bottomAdaptation;
    if (Mach.env.isIOS && Mach.env.safeAreaInsets.bottom && Mach.env.safeAreaInsets.bottom > 0) {
      bottomAdaptation = Mach.env.safeAreaInsets.bottom;
    } else {
      bottomAdaptation = defaultBottom;
    }
    return bottomAdaptation;
  }

  //扩充购物车传来的groupSkuList数据
  private replenishSkuGroupList = () => {
    if (this.defaultGoodData && this.defaultGoodData.groupList?.length > 0) {
      const defaultGroupList = this.defaultGoodData.groupList;
      const length = defaultGroupList?.length;
      const groupListData = this.curGoodDetail.skuList.find((item) => (item.skuId === this.defaultGoodData?.skuId))?.groupList;
      const replenishGroupList: any[] = [];
      for (let i = 0; i < length; i++) {
        const groupId = defaultGroupList[i].groupId;
        const defGroupSkuList = defaultGroupList[i].groupSkuList;
        const groupData = groupListData?.find((item) => (item.groupId === groupId));
        if (groupData) {
          //筛出来购物车里的groupSku
          const apiGroupSkuList = groupData.groupSkuList.filter((item1) => defGroupSkuList.some(((item2) => item2.groupSkuId === item1.groupSkuId)));
          const reGroupskuList = defGroupSkuList.map((item: DefaultGroupSkuList) => {
            const curItem = apiGroupSkuList.find((apiGroupSku) => (apiGroupSku.groupSkuId === item.groupSkuId));
            if (curItem) {
              return { ...curItem, count: item.count || 1 };
            }
          });
          replenishGroupList.push({ groupId, groupSkuList: reGroupskuList });
        }
      }
      return replenishGroupList;
    } else {
      console.log('============没从购物车传值过来===============');
      return undefined;
    }
  }
}

const Store = new MultiSkuStore();
export default Store;
